import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHotDrinkCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHotDrinkCup"><Path fillRule="evenodd" clipRule="evenodd" d="M6.38197 2H17.618L19.118 5H21V10H19.9544L18.737 22H5.26298L4.04559 10H3V5H4.88197L6.38197 2ZM7.11803 5H16.882L16.382 4H7.61803L7.11803 5ZM19 8V7H5V8H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHotDrinkCup;
